var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover07"},[_c('figure',{staticClass:"banner"},[_c('img',{staticClass:"img",attrs:{"src":require(("@/assets/images/" + _vm.image + ".jpg"))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }